import http from "./index";

export default {
  /*获取领导名字*/
  getLeaderNameList: function() {
    return http.post("/index/getLeaderNameList");
  }
};



// WEBPACK FOOTER //
// ./src/api/aboutApi.js